export default "__VITE_ASSET__ee0c8b5f__"